export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

// 独自認証システムのため、ログインページへのパスを定義
export const LOGIN_PATH = "/login";
export const SIGNUP_PATH = "/signup";

// 後方互換性のため、getLoginUrl関数を残す（ログインページにリダイレクト）
export const getLoginUrl = () => {
  return LOGIN_PATH;
};
